import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN = '[VeranstaltungenModul] GetFunkprotokollVorlageDetailAdmin laden';
export const GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] GetFunkprotokollVorlageDetailAdmin ausführen';
export const GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] GetFunkprotokollVorlageDetailAdmin laden erfolgreich';
export const GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_FEHLER = '[VeranstaltungenModul] GetFunkprotokollVorlageDetailAdmin Ladefehler';
export const GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetFunkprotokollVorlageDetailAdmin nicht ausgeführt (evtl. Offline)';


export class GetFunkprotokollVorlageDetailAdminAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN;
        constructor( public id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlageDetailAdminAusfuehrenAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_AUSFUEHREN;
        constructor( public id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlageDetailAdminErfolgreichAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollVorlageDetail,  public id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlageDetailAdminFehlerAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_FEHLER;
        constructor(public payload: any,  public id:string , public optPayload: any = null) {}
    }
export class GetFunkprotokollVorlageDetailAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryFunkprotokollVorlageDetailAdminActions =
    GetFunkprotokollVorlageDetailAdminAction
    | GetFunkprotokollVorlageDetailAdminAusfuehrenAction
    | GetFunkprotokollVorlageDetailAdminErfolgreichAction
    | GetFunkprotokollVorlageDetailAdminFehlerAction
    | GetFunkprotokollVorlageDetailAdminNichtAusgefuehrtAction
    ;
